import { TotemClosedDayType } from 'data/__generated__';

export const TOTEM_CLOSED_DAY_TYPE_LABELS: Record<TotemClosedDayType, string> = {
    [TotemClosedDayType.Other]: 'Autre',
    [TotemClosedDayType.BankHoliday]: 'Jour férié',
};
